import {
  BenefitsStep,
  ClassificationStep,
  ExtrasStep,
  InfoStep,
  MediaStep,
  PointsStep,
  PricingStep,
  ShippingStep,
} from "./steps";
import {
  STEP_BENEFITS,
  STEP_CLASSIFICATION,
  STEP_EXTRAS,
  STEP_INFO,
  STEP_MEDIA,
  STEP_POINTS,
  STEP_PRICING,
  STEP_SHIPPING,
} from "../productSteps";

export interface ProductWizardBodyProps {
  step: number;
  /** `true` al editar: el slug queda bloqueado. */
  locked: boolean;
}

/**
 * Qué paso se pinta.
 *
 * Existe separado de la página por una razón concreta: la página ya
 * lleva el formulario, el wizard, el envío y el reparto de errores del
 * servidor; siete ramas más de JSX la volverían ilegible justo donde vive
 * la lógica que importa. Aquí solo hay una tabla de "índice → paso".
 *
 * Los índices vienen con NOMBRE de `productSteps.ts`. Con números
 * sueltos, quitar un paso de en medio renumeraría todo en silencio y el
 * paso 7 pasaría a pintar el 6 sin que nada dejara de compilar — que es
 * exactamente lo que podría haber pasado al deshacer los dos cortes.
 */
export function ProductWizardBody({ step, locked }: ProductWizardBodyProps) {
  switch (step) {
    case STEP_INFO:
      // El paso 1 quedó SOLO con contenido: el slug se mudó al paso 2,
      // que es quien recibe ahora el `locked`.
      return <InfoStep />;
    case STEP_CLASSIFICATION:
      return <ClassificationStep locked={locked} />;
    case STEP_PRICING:
      return <PricingStep />;
    case STEP_POINTS:
      return <PointsStep />;
    case STEP_BENEFITS:
      return <BenefitsStep />;
    case STEP_EXTRAS:
      return <ExtrasStep />;
    case STEP_SHIPPING:
      return <ShippingStep />;
    case STEP_MEDIA:
      return <MediaStep />;
    default:
      return null;
  }
}
